import api from './utilPartner';

const controller = 'PropostaAvalista';
const url = process.env.VUE_APP_ROOT_API + 'PropostaAvalista';
export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: function (dto) {
    return api.Axios.GetParams(`${url}/Listar`, dto);
  }
});
